"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("../config"));
const axios_1 = __importDefault(require("axios"));
class Auth {
    static async Login(org_code, username, password) {
        const params = new URLSearchParams();
        params.append('username', username);
        params.append('password', password);
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        };
        try {
            let data = await axios_1.default.post(`${config_1.default.ONLINE_API_URL}/api/${org_code}/token`, params, options);
            if (config_1.default.IS_CLI) {
                if (data.headers['set-cookie'] && data.headers['set-cookie'].length > 0) {
                    config_1.default.SetCookie(data.headers['set-cookie'][0]);
                }
            }
            return data.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
exports.default = Auth;
;
